import { reportUnitPerformanceTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_UNIT_PERFORMANCE_FILTERS,
  RESTORE_INITIAL
} = reportUnitPerformanceTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportUnitPerformanceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_UNIT_PERFORMANCE_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
